export default __webpack_public_path__ + "static/media/NONBINARY_SPACE.448790f0.glb";